/* =============================================================
   JMM Pourquoi — bascule Sans/Avec. Auto-flip une fois vers "Avec"
   (débrayable), puis contrôle utilisateur. Multi-instances.
   ============================================================= */
(function () {
  'use strict';

  function initJmp(root) {
    if (root.hasAttribute('data-jmp-init')) return;
    root.setAttribute('data-jmp-init', '1');

    var tgl = root.querySelector('.jmp__tgl');
    var opts = root.querySelectorAll('.jmp__opt');
    var rows = root.querySelectorAll('.jmp__rw');
    if (!tgl) return;

    var touched = false;
    var autoTimer = null;

    function cascade() {
      rows.forEach(function (r, i) {
        r.classList.add('is-out');
        window.setTimeout(function () { r.classList.remove('is-out'); }, 70 * i + 80);
      });
    }

    function setMode(avec) {
      root.classList.toggle('is-avec', avec);
      root.classList.toggle('is-sans', !avec);
      tgl.setAttribute('aria-checked', avec ? 'true' : 'false');
      opts.forEach(function (o, i) { o.classList.toggle('is-on', (i === 1) === avec); });
      cascade();
    }

    tgl.addEventListener('click', function () {
      touched = true;
      window.clearTimeout(autoTimer);
      setMode(!root.classList.contains('is-avec'));
    });

    /* Auto-flip vers "Avec" quand la section entre à l'écran */
    var delay = parseInt(root.getAttribute('data-jmp-delay'), 10) || 0;
    if (delay > 0 && 'IntersectionObserver' in window) {
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !seen) {
            seen = true;
            io.disconnect();
            autoTimer = window.setTimeout(function () {
              if (!touched) setMode(true);
            }, delay);
          }
        });
      }, { threshold: 0.35 });
      io.observe(root);
    } else if (delay > 0) {
      autoTimer = window.setTimeout(function () { if (!touched) setMode(true); }, delay + 800);
    }
  }

  function initAll() { document.querySelectorAll('.jmp').forEach(initJmp); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(initAll, 0); });
})();
